var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.893555,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#F6E003"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5003,
    cy: 40.3939,
    r: 35.8792,
    stroke: "black",
    strokeWidth: 0.658333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2809 24.2002C32.3684 24.2002 26.1143 29.4998 26.1143 37.696C26.1143 42.9298 30.1466 49.0852 38.1947 56.1787C38.8201 56.7219 39.7582 56.7219 40.3836 56.1787C48.4153 49.0852 52.4476 42.9298 52.4476 37.696C52.4476 29.4998 46.1934 24.2002 39.2809 24.2002ZM39.2809 40.6585C37.4705 40.6585 35.9893 39.1773 35.9893 37.3669C35.9893 35.5564 37.4705 34.0752 39.2809 34.0752C41.0913 34.0752 42.5726 35.5564 42.5726 37.3669C42.5726 39.1773 41.0913 40.6585 39.2809 40.6585Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e9e8477dbcf6a4714402c45c1bc01528.svg";
export { ForwardRef as ReactComponent };